import img1 from "../../assets/gallery/full/1.avif";
import img2 from "../../assets/gallery/full/2.avif";
import img3 from "../../assets/gallery/full/3.avif";
import img4 from "../../assets/gallery/full/4.avif";
import img5 from "../../assets/gallery/full/5.avif";
import img6 from "../../assets/gallery/full/6.avif";
import img7 from "../../assets/gallery/full/7.avif";
import img8 from "../../assets/gallery/full/8.avif";
import img9 from "../../assets/gallery/full/9.avif";
import img10 from "../../assets/gallery/full/10.avif";
import img11 from "../../assets/gallery/full/11.avif";
import img12 from "../../assets/gallery/full/12.avif";
import blue from "../../assets/gallery/full/blue-eyes.avif";
import brown from "../../assets/gallery//full/brown-eyes.avif";
import gold from "../../assets/gallery/full/golden-eyes.avif";
import rainbow from "../../assets/gallery/full/rainbow-eyes.avif";

export const GalleryImages = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  blue,
  brown,
  gold,
  rainbow,
];
